export default "__VITE_ASSET__n5JTxQSB__"